module.exports = __webpack_public_path__ + "img/ms_b1_img4.904c1764.png";